import { z } from 'zod';

/**
 * Schemas for the per-room Area grouping (RO: "Zonă").
 *
 * Path: `/projects/:projectId/rooms/:roomId/areas`
 *
 * RoomArea is a finer-grained grouping *within* a ProjectRoom. Each room owns
 * its own areas; component items (cabinets, panels, …) may optionally be
 * assigned to one via `areaId`. An area has a name and an orderIndex for
 * sorting in the UI.
 */

export const roomAreaListItem = z.object({
  id: z.string().cuid(),
  roomId: z.string().cuid(),
  name: z.string(),
  orderIndex: z.number().int(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type RoomAreaListItem = z.infer<typeof roomAreaListItem>;

export const createAreaRequest = z.object({
  name: z.string().trim().min(1).max(200),
  orderIndex: z.number().int().min(0).optional(),
});
export type CreateAreaRequest = z.infer<typeof createAreaRequest>;

export const updateAreaRequest = z
  .object({
    name: z.string().trim().min(1).max(200).optional(),
    orderIndex: z.number().int().min(0).optional(),
  })
  .refine((v) => v.name !== undefined || v.orderIndex !== undefined, {
    message: 'At least one field is required.',
  });
export type UpdateAreaRequest = z.infer<typeof updateAreaRequest>;

export const listAreasResponse = z.array(roomAreaListItem);
export type ListAreasResponse = z.infer<typeof listAreasResponse>;
